<template>
  <v-container fluid>
    <!-- <Loading :msg='loadingMessage' v-if="loading"></Loading> -->
    <v-alert v-model="alert" outline type="success">{{ alertMessage }}</v-alert>
    <v-dialog v-model="confirmDelete" max-width="290">
      <v-card>
        <v-card-title class="headline">Delete Lot?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="doConfirmDelete(false)"
          >
            Cancel
          </v-btn>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="doConfirmDelete(true)"
          >
            Yes, Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <v-toolbar>
        <v-flex xs2>
          <v-switch
            label="Show All Lots"
            color="primary"
            v-model="showAllLots"
            hide-details
          ></v-switch>
        </v-flex>
        <v-flex xs2>
          <v-switch
            label="Show Analysis"
            color="primary"
            v-model="showAnalysis"
            hide-details
          ></v-switch>
        </v-flex>
        <v-spacer></v-spacer>
        <v-toolbar-title
          ><h4>{{ client.CLIENTNAME }} - {{ vintage }}</h4></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn color="primary" class="row end-xs" @click="newLotClicked"
          >New Lot</v-btn
        >
        <v-btn color="primary" class="row end-xs" @click="createBOL"
          >New BOL</v-btn
        >
        <v-btn color="primary" class="row end-xs" @click="generatePDF"
          >PDF</v-btn
        >
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">Lot: {{ editedItem.lotNumber }}</span>
              <v-spacer></v-spacer>
              <v-flex xs2 v-if="editedIndex === -1">
                <v-select
                  :items="allVintages"
                  label="Vintage"
                  v-model="selectedVintage"
                >
                </v-select>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md10>
                    <v-text-field
                      v-model="editedItem.description"
                      label="Description"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md10>
                    <v-text-field
                      v-model="editedItem.labelName"
                      label="Bottled Label Name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-checkbox
                      color="primary"
                      v-model="editedItem.isOrganic"
                      label="Organic"
                      @change="organicStateChanged"
                    >
                    </v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click.native="close">Cancel</v-btn>
              <v-btn color="primary" flat @click.native="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
      </v-card>
      <v-data-table
        :headers="headers"
        :items="lotsTable"
        :search="search"
        item-key="lotNumber"
        hide-actions
        class="elevation-1"
      >
        <!-- <template slot="headers" slot-scope="props">
            <tr>
              <th v-for="header in props.headers" :key="header.text">
                {{header.text}}
              </th>
            </tr>
          </template> -->
        <template slot="items" slot-scope="props">
          <tr>
            <td width="50px" style="text-align: center">
              <v-checkbox
                color="primary"
                hide-details
                v-model="props.item.isActive"
                @change="itemClicked(props.item)"
              ></v-checkbox>
            </td>
            <td width="150px" @click="rowClicked(props.item)">
              {{ props.item.lotNumber }}
            </td>
            <td @click="rowClicked(props.item)">
              {{ props.item.description }}
            </td>
            <td @click="rowClicked(props.item)">{{ props.item.labelName }}</td>
            <td class="text-xs-right">
              <div v-if="showAnalysis == true && props.item.structure">
                {{ numberFormat(props.item.structure.volume.total) }}
              </div>
            </td>
            <td class="text-xs-right">
              <div v-if="showAnalysis == true && props.item.structure">
                {{ numberFormat(props.item.structure.volume.total / 2.3775) }}
              </div>
            </td>
            <td class="text-xs-right">
              <div v-if="showAnalysis == true && props.item.structure">
                {{ numberFormat(props.item.structure.state) }}
              </div>
            </td>
            <td width="50px" style="text-align: center">
              <div v-if="props.item.isOrganic">YES</div>
              <!-- <v-checkbox color="primary" hide-details v-model="props.item.isOrganic" readonly></v-checkbox> -->
            </td>
            <td width="100px" class="justify-end">
              <v-icon
                color="primary"
                small
                class="mr-2"
                @click="editItem(props.item)"
              >
                edit
              </v-icon>
              <v-icon
                v-if="props.item.woCount == 0"
                color="alert"
                small
                @click="deleteItem(props.item)"
              >
                delete
              </v-icon>
            </td>
          </tr>
        </template>
        <template slot="footer" v-if="showAnalysis == true">
          <td>Totals:</td>
          <td></td>
          <td></td>
          <td></td>
          <td class="text-xs-right" v-if="showLotVolumes()">
            {{ totalGallons }}
          </td>
          <td class="text-xs-right" v-if="showLotVolumes()">
            {{ totalCases }}
          </td>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import async from 'async'
import numeral from 'numeral'
import Loading from './Loading'
import DeleteConfirmation from './DeleteConfirmation'
// import { debug, debuglog } from 'util'
export default {
  data () {
    return {
      lotsTable: [],
      loading: false,
      showAllLots: true,
      showAnalysis: false,
      loadingMessage: 'Retrieving Lots...',
      alert: false,
      alertMessage: '',
      allVintages: [],
      selectedVintage: 0,
      confirmDelete: false,
      selected: [],
      showSuccessBanner: false,
      editedItem: {
        lotNumber: '',
        description: '',
        labelName: ''
      },
      editedIndex: -1,
      dialog: false,
      search: '',
      headers: [
        { text: 'Active', value: 'active', sortable: false },
        { text: 'Lot Number', value: 'lotNumber', sortable: true },
        { text: 'Description', value: 'description', sortable: true },
        { text: 'Label Name', value: 'labelName', sortable: true },
        { text: 'Gallons', value: 'gallons', sortable: true, align: 'right' },
        { text: 'Cases', value: 'cases', sortable: true, align: 'right' },
        { text: 'State', value: 'state', sortable: true, align: 'right' },
        { text: 'Organic', value: 'organic', sortable: true },
        { text: 'Edit', value: 'name', sortable: false }
      ],
      tableData: []
    }
  },
  created () {
    this.retrieveAllVintages()
    this.buildLotsTable()
  },
  components: {
    DeleteConfirmation,
    Loading
  },
  computed: {
    lots () {
      return this.$store.state.lotsForVintage
    },
    totalGallons () {
      var total = 0
      if (!this.showLotVolumes()) return 0
      this.lotsTable.forEach((lot) => {
        if (lot.structure && lot.structure.volume) {
          total = total + lot.structure.volume.total * 1
        }
      })
      return numeral(total).format('0,0.0')
    },
    totalCases () {
      var total = numeral(this.totalGallons).value() / 2.3775
      return numeral(total).format('0,0.0')
    },
    vintage () {
      return this.$store.state.vintage
    },
    clientcode () {
      return this.$store.state.client.CODE
    },
    lotsUpdated () {
      return this.$store.state.lotsUpdated
    },
    client () {
      return this.$store.state.client
    },
    loadingLots () {
      return this.$store.state.loadingLots
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.$store.commit('updateLots')
    })
  },
  watch: {
    lotsUpdated: function (nv, ov) {
      this.buildLotsTable()
    },
    showAllLots: function (nv, ov) {
      this.buildLotsTable()
    },
    selectedVintage: function (nv, ow) {
      this.updateNewVintage(this.selectedVintage)
    },
    showAnalysis: function (nv, ov) {
      console.log(nv)
      if (nv) {
        this.addAnalysis()
      }
    }
  },
  methods: {
    numberFormat (item) {
      return numeral(item).format('0,0.0')
    },
    generatePDF () {
      let url =
        process.env.VUE_APP_BACKEND +
        'lots?clientcode=' +
        this.$store.state.client.CODE +
        '&year=' +
        this.$store.state.vintage +
        '&pdf=true'
      console.log(url)
      window.open(
        url,
        '_blank' // <- This is what makes it open in a new window.
      )

      //      axios.get(url).then((response) => {});
    },
    function () {
      console.log(JSON.stringify(lots, null, 2))
    },
    addAnalysis () {
      let results = {}
      let $this = this
      async.eachOf(
        this.lotsTable,
        function (value, key, callback) {
          let url =
            process.env.VUE_APP_BACKEND +
            'workorders?lot=' +
            $this.lotsTable[key].lotNumber +
            '&finalStructOnly=true'
          axios.get(url).then((response) => {
            results[key] = response.data.data.structure
            $this.$set($this.lotsTable[key], 'structure', results[key])
            callback()
          })
        },
        function (err) {
          if (err) {
            console.log(err)
          } else {
            for (var i = 0; i < $this.lotsTable.length; i++) {
              //            $this.$set($this.lotsTable[i], 'structure', results[i])
            }
          }
        }
      )
    },
    createBOL () {
      this.$router.push({
        path: '/bols/-1'
      })
    },
    showLotVolumes (item) {
      if (this.lotsTable.length === 0) return false
      if (!item) return true
      return item.structure
    },
    buildLotsTable () {
      this.lotsTable = []
      if (this.showAllLots) {
        this.lotsTable = this.lots
      } else {
        this.lots.forEach((item) => {
          if (item.isActive) {
            this.lotsTable.push(item)
          }
        })
      }
      if (this.showAnalysis) {
        this.addAnalysis()
      }
    },
    itemClicked (value) {
      axios
        .put(process.env.VUE_APP_BACKEND + 'lots/' + value.id, value)
        .then((response) => {
          this.$store.commit('updateLots')
        })
    },
    filterLots (item, search) {
      return true
    },
    newLotClicked () {
      this.updateNewVintage(this.vintage)
      this.dialog = true
      this.editedIndex = -1
      this.editedItem.description = ''
    },
    retrieveAllVintages () {
      axios
        .get(process.env.VUE_APP_BACKEND + 'lots/uniqueVintageYears')
        .then((response) => {
          this.allVintages = response.data.data
          this.selectedVintage = this.vintage
          this.loading = false
        })
    },
    showAlert (message) {
      this.dialog = false
      this.editedIndex = -1
      this.editedItem = {}
      this.alertMessage = message
      this.alert = true
      let $this = this
      setTimeout(function () {
        $this.alert = false
      }, 1000)
    },
    updateNewVintage (vintage) {
      this.loading = true
      axios
        .get(
          process.env.VUE_APP_BACKEND +
            'lots/newLotNumber?year=' +
            vintage +
            '&clientcode=' +
            this.client.clientid
        )
        .then((response) => {
          var str = '' + response.data
          var pad = '00'
          var count = pad.substring(0, pad.length - str.length) + str
          var v = vintage.toString().substring(2, 4)
          var code = this.clientcode
          this.editedItem.lotNumber = v + '-' + code + '-' + count
          this.editedItem.year = vintage
          this.loading = false
        })
    },
    organicStateChanged (value) {
      if (value) {
        this.editedItem.ORGANIC = 'YES'
      } else {
        this.editedItem.ORGANIC = 'NO'
      }
    },
    doConfirmDelete (value) {
      if (!value) {
        this.confirmDelete = false
      } else {
        let lot = this.$store.state.lotsForVintage[this.editedIndex]
        this.confirmDelete = false
        this.showAlert('Lot successfully deleted!')
        axios
          .delete(process.env.VUE_APP_BACKEND + 'lots/' + lot.id)
          .then((response) => {
            this.$store.commit('updateLots')
          })
      }
    },

    save () {
      if (this.editedIndex > -1) {
        axios
          .put(
            process.env.VUE_APP_BACKEND + 'lots/' + this.editedItem.id,
            this.editedItem
          )
          .then((response) => {
            this.$store.commit('updateLots')
          })
      } else {
        this.editedItem.description = this.editedItem.description.toUpperCase()
        this.editedItem.clientcode = this.client.clientid
        this.editedItem.FAVORITE = 'YES'
        axios
          .post(process.env.VUE_APP_BACKEND + 'lots', this.editedItem)
          .then((response) => {
            this.$store.commit('updateLots')
          })
      }
      this.close()
    },
    editItem (item) {
      this.editedIndex = this.$store.state.lotsForVintage.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.$store.state.lotsForVintage.indexOf(item)
      this.confirmDelete = true
    },
    close () {
      this.dialog = false
      this.editedIndex = -1
    },
    rowClicked (item) {
      this.$router.push({
        path: '/workorders/' + item.lotNumber
      })
    }
  }
}
</script>
<style>
</style>
